import $ from 'jquery';

export const fblogin = (fbuser) => ({type: 'FB_LOGIN',payload: fbuser});
export const fblogout = () => ({type: 'FB_LOGOUT'});

export const login = (userid) => ({type: 'LOGIN',payload: userid});
export const logout = () => (dispatch) => {
  dispatch({type: 'LOGOUT'});
  localStorage.setItem('kod','');
  dispatch(userInfo(null));

}

export const loading = () => ({type: 'LOADING'});
export const userInfo = (info) => ({type: 'USER_INFO',payload: info});
export const userNotFound = () => ({type: 'USER_NOTFOUND'});
export const userEllenorzes = () => ({type: 'ELLENORIZNI_KELL'});
export const connectionError = (error) => ({type: 'CONNECTION_ERROR',payload:error});

export const loadInfo = (nev,kod) => (dispatch) => {
  console.log('loadInfo');
  dispatch(loading());

  console.log("getting info for "+nev);
  $.ajax('https://uttars.prevost.hu/userdata2.php', {
    method: 'POST',
    data: {nev,kod},
  })
  .then( response => {
    console.log(response);
    if(!response){
      dispatch(connectionError('Nem érkezett válasz'));
    }else if(response.error){
      dispatch(connectionError(response.error));
    }else if(response.ellenorzes){
      dispatch(userEllenorzes());      
    }else if(response.info){
      dispatch(userInfo(response.info));
      dispatch(login(response.uttars.sorszam));
    }else{
      dispatch(userNotFound());
    }
  })
  .catch( error => {
    console.error(error);
    dispatch(connectionError(error));
  });
};


// WEBPACK FOOTER //
// ./src/actions.js